import { Dispatch, DispatchWithoutAction, SetStateAction, useCallback } from 'react';

export function useToggle(setValue: Dispatch<SetStateAction<boolean>>): DispatchWithoutAction {
  return useCallback(() => setValue((value) => !value), [setValue]);
}
